import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Navbar from "../../components/Navbar";
import DICOMList from "../../components/DICOM/DICOMList";
import { useLocation, Link } from "react-router-dom";
import "./DICOMListPage.css";
import CSVImportModal from "../../components/CSVImportModal";

const DICOMListPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const patientId = searchParams.get("patient");
  const studyId = searchParams.get("study");
  let createLink = `/dicoms/create`;
  if (patientId) createLink += `?patient=${patientId}`;
  if (studyId) createLink += patientId ? `&study=${studyId}` : `?study=${studyId}`;

  const [isModalOpen, setModalOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const downloadTimeoutRef = useRef(null);
  const [showDownloadDropdown, setShowDownloadDropdown] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const handleRefresh = () => setRefreshData(prev => prev + 1);

  useEffect(() => {
    console.log("Selected IDs:", selectedIds);
  }, [selectedIds]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (showDownloadDropdown && !event.target.closest('.download-dropdown-container')) {
        setShowDownloadDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDownloadDropdown]);

  const handleDownload = (onlyCsv) => {
    if (selectedIds.length === 0) {
      alert("Please select at least one DICOM to download");
      return;
    }
    if (downloadInProgress) {
      return; 
    }
    if (downloadTimeoutRef.current) {
      clearTimeout(downloadTimeoutRef.current);
    }
    downloadTimeoutRef.current = setTimeout(async () => {
      setDownloadInProgress(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/patients/dicoms/download?onlyCsv=${onlyCsv}`,
          {
            params: { 
              id: selectedIds.join(","),
              onlyCsv: onlyCsv
            },
            headers: { Authorization: `Token ${token}` },
            responseType: "blob", 
          }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        
        const timestamp = new Date().toISOString().replace(/[:.]/g, "").substring(0, 15);
        const filename = onlyCsv ? `dicoms_${timestamp}.csv` : `dicoms_${timestamp}.zip`;
        link.setAttribute("download", filename);
        
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Error downloading DICOMs:", error);
        alert("Error downloading DICOMs. Please try again.");
      }
      setDownloadInProgress(false);
      setShowDownloadDropdown(false);
    }, 300);
  };

  return (
    <div className="dicom-list-page">
      <Navbar />
      <div className="dicom-list-content">
        <div className="dicom-header-section">
          <h2>XA DICOMs</h2>
          <div className="button-group">
            <Link to={createLink} className="dicom-create-btn-main">
              New XA DICOM
            </Link>
            <button className="csv-import-btn" onClick={openModal}>
              CSV Import
            </button>
            
            <div className="download-dropdown-container">
              <button
                className="download-btn"
                onClick={() => setShowDownloadDropdown(!showDownloadDropdown)}
                disabled={selectedIds.length === 0 || downloadInProgress}
              >
                Download Selected ({selectedIds.length}) ▼
              </button>
              
              {showDownloadDropdown && (
                <div className="download-dropdown-menu">
                  <button 
                    onClick={() => handleDownload(true)}
                    disabled={downloadInProgress}
                  >
                    Download CSV
                  </button>
                  <button 
                    onClick={() => handleDownload(false)}
                    disabled={downloadInProgress}
                  >
                    Download All Data
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <DICOMList refreshData={refreshData} onSelectedIdsChange={setSelectedIds} />
      </div>
      <CSVImportModal
        type={"dicoms"}
        isOpen={isModalOpen}
        onClose={closeModal}
        onSuccess={() => {
          handleRefresh();
          closeModal();
        }}
      />
    </div>
  );
};

export default DICOMListPage;
